import {connect} from 'react-redux';

import CommentIcon from 'components/common/comment_icon';

function makeMapStateToProps() {
    return () => {
        return {
            commentCount: 0,
        };
    };
}

export default connect(makeMapStateToProps)(CommentIcon);
